// extracted by mini-css-extract-plugin
export default {"values-title":"values-title___e4ZL8","label":"label___is14r","value":"value___MMxsi","container":"container___j54f1","row":"row___Q5mXY","row-ellipsis":"row-ellipsis___ymWRn"};